import { apiClient } from '../../../utilities/apiClient';

// Single round-trip to the backend's GET /admin/stats. Returns the full
// AdminStats payload (counts + recent signups). The admin Dashboard reads
// this on mount and on operator-triggered refresh; no polling for now.
export const fetchStats = async () => {
  const res = await apiClient.get('/admin/stats');
  return res.data;
};
